export default "__VITE_ASSET__DZXfvSHX__"